import React from "react";
// @ts-ignore
import Icon from "../../../_static/Icons";
// @ts-ignore
import { key } from "../../../_static/Icons/iconsDuotone";
// @ts-ignore
import buildColor from "../../../_static/ColorPalette";
import {
  ExoticBetContainer,
  HorizontalRule,
  LabelItem,
  RunnerNumberContainer,
  TextLabel
} from "../styled-components";

export interface ExoticBetsLayoutProps {
  isBetsDetailedView: boolean;
  isDesktop: boolean;
  label: string;
  isKey: boolean;
  showHorizontalRule: boolean;
  runnerNumberGroup: React.ReactNode;
}

const ExoticBetsLayout = ({
  isDesktop,
  isKey,
  label,
  runnerNumberGroup,
  isBetsDetailedView,
  showHorizontalRule
}: ExoticBetsLayoutProps) => (
  <ExoticBetContainer
    data-qa-label="myBets-exoticBet-container"
    isDesktop={isDesktop}
  >
    {(isKey || label) && (
      <LabelItem isDesktop={isDesktop}>
        {!isKey ? (
          <TextLabel
            data-qa-label="myBets-exoticBet-label"
            isDesktop={isDesktop}
          >
            {label}
          </TextLabel>
        ) : (
          <Icon
            qaLabel="myBets-exoticBet-icon"
            icon={key}
            viewBoxSize={16}
            size={16}
            color={buildColor("white", "10")}
            stroke={buildColor("grey", "800")}
          />
        )}
      </LabelItem>
    )}
    <RunnerNumberContainer>
      {runnerNumberGroup}
      {showHorizontalRule && isBetsDetailedView && (
        <HorizontalRule isDesktop={isDesktop} />
      )}
    </RunnerNumberContainer>
  </ExoticBetContainer>
);

export default ExoticBetsLayout;
